import { gql } from "@apollo/client";

export const createDutyRequestMutation = gql`
mutation CreateDutyRequest($input: DutyRequestInput!) {
  createDutyRequest(input: $input) {
    message
    response
  }
}
`;

export const cancelDutyRequestMutation = gql`
mutation CancelDutyRequest($requestId: String!) {
  cancelDutyRequest(requestId: $requestId) {
    message
    response
  }
}
`;

export const saveCustomerPushSubscriptionMutation = gql`
mutation SaveCustomerPushSubscription($subscription: String!) {
  saveCustomerPushSubscription(subscription: $subscription) {
    message
    response
  }
}
`;

export const updateDutyRequestMutation = gql`
mutation UpdateDutyRequest($input: UpdateDutyRequestInput!) {
  updateDutyRequest(input: $input) {
    message
    response
  }
}
`;
